<template>
<div class="card card21 col col--2x">
  <div class="card_link" @click="open_allow('open_21')">
    <div class="card_nr"><h2 class="nr">21</h2></div>
  </div>
</div>
<!-- TAG 21 -->
<div class="trailer_21">
  <div class="trailer_box">
      <div class="video_box">
          <div class="lds-dual-ring" v-if="loading"></div>
        <video loop autoplay class="video_21" v-if="video_view">
          <source v-bind:src="require('./../assets/videos/' + video_name_mp4_21)" type="video/mp4" />
        </video>
      </div>
      <div class="text_box text_box_21">
        <p>{{text_21_1}}</p>
        <p>{{text_21_2}}</p>
        <p>
          <picture>
                <source v-bind:srcset="require('./../assets/images/' + img_logo_musikschule_webp)" type="image/webp">
                <source v-bind:srcset="require('./../assets/images/' + img_logo_musikschule_png)">
                <img v-bind:srcset="require('./../assets/images/' + img_logo_musikschule_png)" alt="{{img_logo_musikschule_alt}}">
          </picture>
        </p>
      </div>
      <picture>
                <source v-bind:srcset="require('./../assets/images/' + img_close_webp)" type="image/webp">
                <source v-bind:srcset="require('./../assets/images/' + img_close_png)">
                <img class="close" v-bind:srcset="require('./../assets/images/' + img_close_png)" @click="close_21" alt="{{img_close_alt}}">
      </picture>
  </div>
</div>
<!-- TAG GESCHLOSSEN --> 
<div class="trailer_27">
  <div class="trailer_box">
      <div class="text_box text_box_27">
        <p>{{text_27_1}}</p>
        <p>{{text_27_2}}<br />{{text_27_3}}</p>
        <p>
          <picture>
                <source v-bind:src="require('./../assets/images/' + img_logo_musikschule_webp)" type="image/webp">
                <source v-bind:src="require('./../assets/images/' + img_logo_musikschule_png)">
                <img v-bind:src="require('./../assets/images/' + img_logo_musikschule_png)" alt="{{img_logo_musikschule_alt}}">
          </picture>
        </p>
      </div>
      <picture>
                <source v-bind:src="require('./../assets/images/' + img_close_webp)" type="image/webp">
                <source v-bind:src="require('./../assets/images/' + img_close_png)">
                <img class="close_schwarz" v-bind:src="require('./../assets/images/' + img_close_png)" @click="close_27" alt="{{img_close_alt}}">
      </picture>
  </div>
</div>
</template>
<script>
import Moment from 'moment';
export default {
  name: 'KalenderCard21',
  data: function() {
    return {
      /* BILDER */
      img_logo_musikschule_webp: "logo-schloss-rochsburg.webp",
      img_logo_musikschule_png: "logo-schloss-rochsburg.png",
      img_logo_musikschule_alt: "Schloss Rochsburg",
      img_close_webp: "close.webp",
      img_close_png: "close.png",
      img_close_alt: "Schließen",
      /* TAG 21 */
      tag: "21",
      datum: "21.12.2024",
      text_21_1: "Interpretation Ritter Fips ",
      text_21_2: "Gespielt auf: Schloss Rochsburg",
      video_name_webm_21: "21.webm",
      video_name_mp4_21: "21.mp4",
      /* TAG 27 */
      text_27_1: "Neugierig?",
      text_27_2: "Das Türchen darf noch nicht geöffnet werden.",
      text_27_3: "Sei noch etwas geduldig und warte bis zu diesem Tag :)",

      video_view: false,
      loading: false,
      response_webm: '',
      response_mp4: '',
      controller: '',
    }
  },
  methods: {
    trailer() {return true;},
    open_allow(nummer) {
      if(this.isAllowedToView) { // Tag offen
        var open_nr = nummer;
        this[open_nr]();
        this.loadTrailer();
      } 
      else { // Tag gesperrt ... open_27()
        this.open_27();
      }
    },
    async loadTrailer() {
      this.video_view = true;
      this.loading = true;
      this.$http;
      let video_21 = document.querySelector('.video_21');
      //let url_webm = '/media/' + this.video_name_webm_21;
      let url_mp4 = '/media/' + this.video_name_mp4_21;
      this.controller = new AbortController();
      const signal = this.controller.signal
      try {
        //this.response_webm = await this.axios.get(url_webm, {signal});
        this.response_mp4 = await this.axios.get(url_mp4, {signal});
        //console.log('get webm: ' + this.response_webm.statusText); 
        //console.log('get mp4: ' + this.response_mp4.statusText); 
        video_21.currentTime = 0;this.silencePromise(video_21.play());
      } catch(err) {
        //console.log(err.message);
      }
      this.loading = false;
    },
    isPromise(value) {
      return value !== undefined && value !== null && typeof value.then === 'function';
    },
    silencePromise(value) {
      if (this.isPromise(value)) {
        value.then(null, (e) => {console.log(e);});
      }
    },
    stopVideo() {
      let video_21 = document.querySelector('.video_21');
      video_21.load();
      video_21.currentTime = 0;
      this.controller.abort();
      //console.log('abbruch webm: ' + this.response_webm.statusText); 
      //console.log('abbruch mp4: ' + this.response_mp4.statusText); 
      var videos = document.querySelectorAll('video');
      Array.prototype.forEach.call(videos, function (video) {
        if (video.tagName.toLowerCase() === 'video') {
          video.pause();
        } else {
          var src = video.src;
          video.src = src;
        }
      });
    },
    open_21() { var trailer_21 = document.querySelector('.trailer_21');window.scrollTo(0, 0);trailer_21.classList.toggle('active');},
    close_21() {var trailer_21 = document.querySelector('.trailer_21');trailer_21.classList.toggle('active');this.stopVideo();},
    open_27() { var trailer_27 = document.querySelector('.trailer_27');window.scrollTo(0, 0);trailer_27.classList.toggle('active');},
    close_27() {var trailer_27 = document.querySelector('.trailer_27');trailer_27.classList.toggle('active');},
  },
  computed: {
     datumCard: function () {
      return new Moment(this.datum, 'DD.MM.YYYY')
    },
    heute: function () {
      return new Moment()
    },
    isAllowedToView: function () {
      return this.datumCard <= this.heute
    },
  },
}
</script>
<style scoped lang="scss">
@import './../scss/variablen.scss';
@import './../scss/mixins.scss';
@import './../scss/style.scss';
@import './../scss/KalenderCard.scss';
@import './../scss/KalenderCardOpen.scss';
</style>